import { render, staticRenderFns } from "./ContractViewTimelineItemObservation.vue?vue&type=template&id=3f16ba27&scoped=true&"
import script from "./ContractViewTimelineItemObservation.vue?vue&type=script&lang=js&"
export * from "./ContractViewTimelineItemObservation.vue?vue&type=script&lang=js&"
import style0 from "./ContractViewTimelineItemObservation.vue?vue&type=style&index=0&id=3f16ba27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f16ba27",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VDatePicker } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTimelineItem } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardActions,
  VDatePicker,
  VDialog,
  VFlex,
  VIcon,
  VLayout,
  VSpacer,
  VTimelineItem,
})
